<template>
  <div class="container-fluid">
    <vx-card title="Campañas de correo: Audiencias">
      <h6 class="card-subtitle text-muted">Listado de audiencias</h6>

      <div class="row">
        <div class="col-md-12">
          <vs-table :data="audiences" :max-items="30" stripe search pagination>

            <div slot="header" class="flex-grow justify-left">
              <vs-button size="small"
              @click="$router.push('/emails/audiences/new')"
              icon="add_circle_outline"
              color='success'>Nueva
                audiencia</vs-button>
            </div>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Audiencia</vs-th>
              <vs-th>Query</vs-th>
              <vs-th>Tag</vs-th>
              <vs-th>Acciones</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(audience, index) in data" :key="index">
                <vs-td>{{audience.id}}</vs-td>
                <vs-td>
                  <vs-button @click.stop="loadPreviewList(audience.id)"
                  size='small'>{{audience.description}}
                  </vs-button>
                </vs-td>
                <vs-td style="width: 500px">{{audience.db_query}}</vs-td>
                <vs-td>{{audience.tag}}</vs-td>
                <vs-td>
                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    class="ml-6" @click.stop="$router.push(`/emails/audiences/update/${audience.id}`)" />

                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    class="ml-6" @click="deleteAudience(audience.id)" />
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </div>
    </vx-card>

    <vs-popup :active.sync="modal.show" :title="modal.title">
      <h5>Total: {{modal.counterAudience}}</h5>
      <ul>
        <li v-for="(user,i) in audienceList" v-bind:key="i">{{user.name}} - {{user.email}}</li>
      </ul>

      <div class="mt-6">
        <vs-button color="dark" @click="closeModal">Cerrar</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
  export default {
    name: "Audiences",
    data: () => ({
      audiences: [],
      audienceList: [],
      modal: {
        show: false,
        title: 'Audiences: #',
        content: '',
        counterAudience: ''
      },
    }),
    async mounted() {
      this.startLoading();
      await axios.get(`/api/app-http-services/services/notifications/email/audiences`)
        .then(response => this.audiences = response.data);
      this.stopLoading();
    },
    methods: {
      closeModal(){
        this.modal.show = false;
      },
      async deleteAudience(audience_id) {
        swal({
            title: `¿Esta seguro de eliminar la audiencia #${audience_id}?`,
            text: "* Esta acción no se puede revertir",
            icon: "warning",
            buttons: true,
            dangerMode: true,
          })
          .then(async (willDelete) => {
            if (willDelete) {
              try {
                await axios.delete(`/api/app-http-services/services/notifications/email/audiences/${audience_id}`)
                location.reload();
              } catch (e) {
                if (e.response.status === 422) {
                  await swal("Notificación", JSON.stringify(e.response.data.errors), "warning")
                }
                if (e.response.status === 500) {
                  await swal("Error", "Hubo un error al actualizar la audiencia", "error")
                }
              }
            } else {
              swal("¡Acción cancelada!");
            }
          });
      },
      async loadPreviewList(audience_id) {
        this.startLoading();
        this.modal.show = true;
        this.modal.title = `Audiences: #${audience_id}`;
        await axios.get(`/api/app-http-services/services/notifications/email/audiences/get-query/${audience_id}`)
          .then(response => this.audienceList = response.data);
        this.modal.counterAudience = this.audienceList.length;
        this.stopLoading();
      }
    }
  }
</script>

<style>
.vs-pagination--buttons,
.vs-table--thead,
.vs-table--tbody,
.vs-button--icon {
  z-index: 1 !important;
}
</style>
